import { useErrorStore } from "@/store/error-store";

/**
 * Sets the given FatalError instance to the ErrorStore, triggering the Vue Apps error handler
 * @param {import("./FatalError")} err
 */
export const setFatalError = (err) => {
  useErrorStore().setError(err);
};
